import React, { useEffect, useRef } from 'react'
import { colorify, getColors, replaceColor } from 'lottie-colorify'

import kenkoLoader from '../../../public/animations/KenkoLoader'
import Lottie from 'lottie-web'
import { useTheme } from 'styled-components'

const KenkoLoader = ({ size = 60 }) => {
  const container = useRef(null)
  const theme = useTheme()

  useEffect(() => {
    console.log(theme?.color.brand)
    const animation = Lottie.loadAnimation({
      container: container.current,
      animationData: colorify(
        [
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand,
          [0, 0, 0],
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand,
          theme?.color.brand
        ],
        kenkoLoader
      )
    })
  }, [])

  return (
    <div
      ref={container}
      style={{
        width: '100%',
        height: size,
        justifyContent: 'center',
        display: 'flex'
      }}
    />
  )
}

export default KenkoLoader
